import * as React from 'react';
import { UtilityText } from '@leagueplatform/genesis-core';
import type { EntityDetail } from '@web-config-app/core';
import { useIntl } from '@leagueplatform/locales';
import { getTimeSinceLastUpdated } from '../get-time-since-last-updated';
import { LinkableCell } from '../table-pieces.component';

export type RelativeTimeCellProps = {
  item: EntityDetail;
  linkTo?: string;
};

export const RelativeTimeCell: React.FC<RelativeTimeCellProps> = ({
  item,
  linkTo,
}) => {
  const { formatRelativeTime } = useIntl();
  const [value, unit] = getTimeSinceLastUpdated(
    item.attributes.entityMetadata?.lastUpdatedDate,
  );
  return (
    <LinkableCell linkTo={linkTo}>
      <UtilityText>
        {formatRelativeTime(value, unit, { numeric: 'auto' })}
      </UtilityText>
    </LinkableCell>
  );
};
